// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- design system */
.RadioGroup-module__Container___FSRO {
    width: 100%;
}

.RadioGroup-module__Label__GEmIK {
    /* Using margin because of: https://stackoverflow.com/questions/28078681/why-cant-fieldset-be-flex-containers */
    margin-bottom: var(--ds-4x);
    font-weight: var(--ds-font-weight-bold);
    font-size: var(--ds-font-size-xs);
    line-height: var(--ds-line-height);
    letter-spacing: var(--ds-letter-spacing-subtitle);
    text-transform: uppercase;
}

.RadioGroup-module__RowsWrapper__FAMNZ {
    display: flex;
    flex-direction: row;
    gap: var(--ds-4x);
}

.RadioGroup-module__Row__CH1mj {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: var(--ds-4x);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `RadioGroup-module__Container___FSRO`,
	"Label": `RadioGroup-module__Label__GEmIK`,
	"RowsWrapper": `RadioGroup-module__RowsWrapper__FAMNZ`,
	"Row": `RadioGroup-module__Row__CH1mj`
};
export default ___CSS_LOADER_EXPORT___;
